<span #spanElement>
  <ng-content></ng-content>
</span>
